import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.scss";
import { ReactComponent as UserProfileIcon } from "../assets/icons/user_profile.svg";
import { ReactComponent as BackwardIcon } from "../assets/icons/Backward.svg";
import MiniLogo from "../assets/images/mini_logo.png";
import i18next from "i18next";
import { Select } from "antd";
import { useTranslation } from "react-i18next";

// Dil kodlarını görüntülenen etiketlere eşleme
const languageMap = {
  'en': 'Eng',
  'az': 'Aze',
  'ru': 'Ru',
  'en-US': 'Eng'
};

const Header = ({ title, showBackIcon, showProfileIcon, onBackClick, hideIcons }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language || localStorage.getItem('i18nextLng') || 'az');
  const [userData, setUserData] = useState(null);
  
  // Görüntülenecek dil etiketini al
  const getDisplayLanguage = (langCode) => {
    return languageMap[langCode] || langCode;
  };
  
  const toggleLang = (lang) => {
    // Eğer tam dil kodu gelirse (en-US gibi), sadece ana dil kodunu al (en)
    const mainLangCode = lang.split('-')[0];
    i18next.changeLanguage(mainLangCode);
    setCurrentLang(mainLangCode);
    localStorage.setItem('i18nextLng', mainLangCode);
    // Sayfayı yenilemeden çevirilerin hemen uygulanmasını sağlamak için
    if (window.location.pathname.includes('/maintenance/')) {
      // Şu anki rota
      const currentPath = window.location.pathname;
      // Sayfayı yenile
      navigate(currentPath, { replace: true });
    }
  };
  
  useEffect(() => {
    // Mevcut dili al ve state'i güncelle
    const storedLang = localStorage.getItem('i18nextLng');
    if (storedLang && storedLang !== currentLang) {
      setCurrentLang(storedLang);
    }
    
    // Dil değişikliğini dinle
    const handleLanguageChange = (lng) => {
      setCurrentLang(lng);
    };
    
    i18n.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem("user"));
    if (storedUserInfo) {
      setUserData(storedUserInfo);
    }
  }, []);
  
  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };
  
  const handleProfileClick = () => {
    if (localStorage.getItem("token")) {
      navigate("/account");
    } else {
      navigate("/login");
    }
  };

  return (
    <header className="main-header">
      <div className="header-content">
        <div className="header-left">
          <div className="mini-logo" onClick={() => navigate('/home')}>
            <img src={MiniLogo} alt="E-Prorab Logo" />
          </div>
          {showBackIcon && (
            <div className="back-icon" onClick={handleBackClick}>
              <BackwardIcon />
            </div>
          )}
        </div>
        {title && <div className="header-title">{title}</div>}
        {!hideIcons && showProfileIcon && (
          <div className="header-right">
            <div className="profile-icon" onClick={handleProfileClick}>
              <UserProfileIcon />
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
